import React from "react";

export default function AddressSelector({ locations, selectedID, setSelectedID, countries, onAddNew, addLabel }) {
    return (
        <div className="row g-0">
            {locations.map(option => {
                const id = option.LocationID || option.BillingID;
                return (
                    <div className="col-md-3 mb-3 p-0" key={id}>
                        <div
                            className={`card h-100 mx-2 ${selectedID === id ? "border-primary shadow bg-primary text-white" : "border"}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedID(id)}
                        >
                            <div className="card-body">

                                {/* Prikaz sm_name samo za billing */}
                                {option.BillingID && option.sm_name && (
                                    <h4 className="card-title p-0"><strong>{option.sm_name}</strong></h4>
                                )}
                                <h5 className="card-title p-0">{option.company}</h5>
                                {option.BillingID && option.ddv && (
                                    <p className="card-text m-0">Davčna številka: {option.ddv}</p>
                                )}
                                {option.BillingID && option.phone && (
                                    <p className="card-text m-0">Telefon: {option.phone}</p>
                                )}

                                <p className="card-text m-0">{option.address_1}</p>
                                <p className="card-text m-0">{option.postcode} {option.city}</p>
                                <p className="card-text m-0">{countries?.[option.country]}</p>


                            </div>
                        </div>
                    </div>
                );
            })}

            <div className="col-md-3 mb-3 p-0">
                <div
                    className="card h-100 mx-2 d-flex align-items-center justify-content-center border border-dashed"
                    style={{ cursor: "pointer" }}
                    onClick={onAddNew}
                >
                    <div className="card-body text-center">
                     <svg
                                width={50}
                                height={50}
                                viewBox="0 0 32 32"
                                fill="#59a5c3"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                            >
                                <path d="M27.2,8.22H23.78V5.42A3.42,3.42,0,0,0,20.36,2H5.42A3.42,3.42,0,0,0,2,5.42V20.36a3.42,3.42,0,0,0,3.42,3.42h2.8V27.2A2.81,2.81,0,0,0,11,30H27.2A2.81,2.81,0,0,0,30,27.2V11A2.81,2.81,0,0,0,27.2,8.22ZM5.42,21.91a1.55,1.55,0,0,1-1.55-1.55V5.42A1.54,1.54,0,0,1,5.42,3.87H20.36a1.55,1.55,0,0,1,1.55,1.55v2.8H11A2.81,2.81,0,0,0,8.22,11V21.91ZM28.13,27.2a.93.93,0,0,1-.93.93H11a.93.93,0,0,1-.93-.93V11a.93.93,0,0,1,.93-.93H27.2a.93.93,0,0,1,.93.93Z" />
                                <path d="M24.09,18.18H20v-4a.93.93,0,1,0-1.86,0v4h-4a.93.93,0,0,0,0,1.86h4v4.05a.93.93,0,1,0,1.86,0V20h4.05a.93.93,0,1,0,0-1.86Z" />
                            </svg>

                        <h5 className="card-title p-0 m-0">{addLabel}</h5>
                        {/*<p className="card-text text-muted m-0">Dodaj nov naslov</p>*/}
                    </div>
                </div>
            </div>
        </div>
    );
}
